





















































































































































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { TbGoods, TbGoodsClass, TbGrade, TbMember, TbReport } from '@/http';
import { calendarPanel,NumberKeyboard } from "@/components";
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')
import { fmoney } from '@/common/money';
@Component({ 
    components: {
        calendarPanel,NumberKeyboard
    },
})
export default class returnOrder extends Vue {
    public $refs: {
    };

    @Prop({
        type:Object,
        default:()=>{

        }
    })
    form:any;

    gradeList = [];

    /**查询项 */
    searchValue={
        orderNo:"",
        returnType:null,
        startTime:"",
        endTime:"",
        skip:0,
        count:10,
    }
    /**时间类型下拉 */
    showStatusPopover = false;
    typeOptions=[
        {
        label: "全部退款方式",
        value: null,
        },
        {
        label: "现金",
        value: 1,
        },
        {
        label: "会员卡",
        value: 2,
        },
        {
        label: "现金+会员卡",
        value: 3,
        },
        {
        label: "微信",
        value: 4,
        },
        {
        label: "支付宝",
        value: 5,
        },
        {
        label: "线下微信",
        value: 6,
        },
        {
        label: "线下支付宝",
        value: 7,
        },
        {
        label: "线下微信+现金",
        value: 8,
        },
        {
        label: "线下微信+会员卡",
        value: 9,
        },
        {
        label: "线下微信+现金+会员卡",
        value: 10,
        },
        {
        label: "线下支付宝+现金",
        value: 11,
        },
        {
        label: "线下支付宝+会员卡",
        value: 12,
        },
        {
        label: "线下支付宝+现金+会员卡",
        value: 13,
        },
        {
        label: "线下支付宝+现金+会员卡+线下微信",
        value: 14,
        },
        {
        label: "线下支付宝+会员卡+线下微信",
        value: 15,
        },
        {
        label: "线下支付宝+现金+线下微信",
        value: 16,
        },
        {
        label: "线下支付宝+线下微信",
        value: 17,
        },
        
    ]

    /**时间控件 */
    pickerShow = false;
    startDate="";
    endDate="";

    /**列表展示
     * 1:图
     * 2：表格
     */
    showType=1;

    userInfo:any={};

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

    timeActive=null;

    /**新增会员弹窗 */
    addVipShow = false;
    isAdd = true;

    totalInfo:any={};

    fmoney = fmoney;

   get getTypeStatus(){
    let str = "";
    str = this.typeOptions.find(v=>v.value==this.searchValue.returnType).label
    return str;
   }

    created() {
     
    }

    async mounted(){
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        
       
    }

    getPayName(val){
        let str = "";
        str = this.typeOptions.find((v) => v.value == val).label;
        return str;
    }

   
    openselDate() {
        this.pickerShow = true;
    }
    /**确定选择时间 */
    onselConfirm(date){
        const [start, end] = date;
        this.startDate = dayjs(start).format("YYYY-MM-DD");
        this.endDate = dayjs(end).format("YYYY-MM-DD");
    
        this.pickerShow = false;
        this.timeActive = null;
        this.setTimeSearch();
    }
    closeTime(){
        this.pickerShow = false;
    }
    
    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            

            let s = this.searchValue.count;
            let res = await TbReport.GetTbSaleReportList(Object.assign({},this.searchValue,{
                memberPhone:this.form.phone,
                orderType:2,
            }))
            this.list = this.searchValue.skip==0? res.items.map(v=>{
                return{
                    ...v,
                    orderDate:dayjs(v.orderDate).format('YYYY-MM-DD'),
                }
            }):this.list.concat(res.items.map(v=>{
                return{
                    ...v,
                    orderDate:dayjs(v.orderDate).format('YYYY-MM-DD'),
                }
            }));
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            await this.getTotal();
            if (this.list.length >= this.total) {
            this.finished = true;
            console.log('list',this.list);
            
            }
    }
    async getTotal(){
        let res = await TbReport.GetTbSaleReportTotal(Object.assign({},this.searchValue,{
            memberPhone:this.form.phone,
            orderType:2,
        }))
        this.totalInfo = res;
    }
    /**获取商品列表 */
    async getList(){
        // this.onRefresh();
        this.list = [];
        this.searchValue.skip=0;
        this.searchValue.count=10;
        this.total = 0;
        this.currentPage = 1;

        let res = await TbReport.GetTbSaleReportList(Object.assign({},this.searchValue,{
            memberPhone:this.form.phone,
            orderType:2,
        }))
        this.list = res.items.map(v=>{
            return{
                ...v,
                orderDate:dayjs(v.orderDate).format('YYYY-MM-DD'),
            }
        });
        this.total  = res.totalCount;
        await this.getTotal();
    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            orderNo:"",
            returnType:null,
            startTime:"",
            endTime:"",
            skip:0,
            count:10,
        }
        this.timeActive=null;
        this.startDate = "";
        this.endDate = "";
        this.showStatusPopover = false;
        this.onRefresh();
    }
   
    sortFun(val){}
    changeTypeStatusXL(item,index){
        this.showStatusPopover = false;
        this.searchValue.returnType = item.value;
        this.onRefresh();
    }
    async chooseTime(type){
        this.timeActive = type;
        // 获取当前日期
        const today = dayjs();
        const firstDayOfWeek = dayjs().startOf('week');
        const firstDayOfMonth = dayjs().startOf('month');
        const prevMonthStart = today.subtract(1, 'month').startOf('month');  
        const prevMonthEnd = today.subtract(1, 'month').endOf('month')
        switch (type) {
            case 1:
                this.startDate = today.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                break;
            case 2:
                this.startDate = firstDayOfWeek.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                break;
            case 3:
                this.startDate = firstDayOfMonth.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                break;
            case 4:
                this.startDate = prevMonthStart.format("YYYY-MM-DD");
                this.endDate = prevMonthEnd.format("YYYY-MM-DD");
                break;
        
            default:
                break;
        }
        await this.setTimeSearch();
    }
    async setTimeSearch(){
        this.searchValue.startTime = this.startDate+" 00:00:00";
        this.searchValue.endTime = this.endDate+" 23:59:59";
        await this.onRefresh();
    }

    
    
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/vip/components/returnOrder.vue